import classnames from 'classnames';
import React, { ReactNode } from 'react';

import Button from 'common/components/Button';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import trans from 'common/tools/translations/trans';

import styles from './SectionModal.module.scss';

export type SectionModalSection = {
  id: string;
  label: string;
  imageUrl?: string;
  imageAlt?: string;
  shape?: 'circle' | 'rectangle';
  actionLabel: string;
  onActionClick: () => void;
};

export type SectionModalProps = {
  title: string;
  sections: SectionModalSection[];
  navigation?: ReactNode;
  onCancel: () => void;
  onValidate?: () => void;
  cancelLabel?: string;
  validateLabel?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
};

const SectionModal = ({
  title,
  sections,
  navigation,
  onCancel,
  cancelLabel = trans('generic.cancel'),
  size = 'medium',
  className
}: SectionModalProps) => (
  <ReactModal
    size={size}
    title={title}
    className={className ?? styles.sectionModal}
  >
    {navigation ? (
      <div className={styles.navigation} role="navigation">
        {navigation}
      </div>
    ) : null}
    <div className={classnames(styles.sections, 'section-modal__sections')}>
      {sections.map(section => (
        <div
          key={section.id}
          className={styles.section}
          data-section-id={section.id}
        >
          <div
            className={classnames(styles.sectionPreview, {
              [styles.sectionPreviewCircle]: section.shape === 'circle'
            })}
          >
            {section.imageUrl ? (
              <img
                src={section.imageUrl}
                alt={section.imageAlt ?? section.label}
                className={styles.sectionImage}
              />
            ) : (
              <div className={styles.sectionPlaceholder} />
            )}
          </div>
          <span className={styles.sectionLabel}>{section.label}</span>
          <Button
            theme="inverse"
            type="full"
            size="sm"
            className={styles.sectionAction}
            onClick={section.onActionClick}
          >
            {section.actionLabel}
          </Button>
        </div>
      ))}
    </div>
    <div className={classnames(styles.footer, 'section-modal__footer')}>
      <Button
        theme="default"
        type="full"
        size="sm"
        className={styles.footerButton}
        onClick={onCancel}
      >
        {cancelLabel}
      </Button>
    </div>
  </ReactModal>
);

export default SectionModal;
